<!-- eslint-disable vue/no-mutating-props -->
<template>
  <div class="emission-step">
    <h2 class="step-title">¡Bien elegido!</h2>
    <p class="step-subtitle">
      {{ allowEmission
        ? 'Ahora solo necesitamos tus datos personales para emitir tu seguro. ¡Es inmediato!'
        : 'Completa tus datos personales para finalizar tu cotización.' }}
    </p>

    <div class="form-section">
      <div class="section-header">
        <el-icon class="section-icon"><User /></el-icon>
        <span class="section-title">DATOS PERSONALES</span>
      </div>

      <div class="form-grid">
        <div class="form-field">
          <label class="field-label">Paterno <span class="required">*</span></label>
          <el-input v-model="formData.paterno" placeholder="Ingresa tu apellido paterno" class="field-input" />
        </div>

        <div class="form-field">
          <label class="field-label">Materno</label>
          <el-input v-model="formData.materno" placeholder="Ingresa tu apellido materno" class="field-input" />
        </div>

        <div class="form-field">
          <label class="field-label">Nombres <span class="required">*</span></label>
          <el-input v-model="formData.nombres" placeholder="Ingresa tu nombre" class="field-input" />
        </div>

        <div class="form-field">
          <label class="field-label">RFC <span class="required">*</span></label>
          <el-input v-model="formData.rfc" placeholder="Ingresa tu RFC" class="field-input" maxlength="13" />
        </div>

        <div class="form-field">
          <label class="field-label">Fecha de Nacimiento <span class="required">*</span></label>
          <el-date-picker
            v-model="formData.fechaNacimiento"
            type="date"
            placeholder="Selecciona tu fecha de nacimiento"
            format="DD/MM/YYYY"
            value-format="YYYY-MM-DD"
            class="field-input"
          />
        </div>

        <div class="form-field">
          <label class="field-label">Teléfono <span class="required">*</span></label>
          <el-input v-model="formData.telefonos" placeholder="Ingresa tu teléfono" class="field-input" />
        </div>

        <div class="form-field">
          <label class="field-label">Género <span class="required">*</span></label>
          <el-select v-model="formData.genero" placeholder="Selecciona" class="field-input">
            <el-option label="Hombre" value="M" />
            <el-option label="Mujer" value="F" />
          </el-select>
        </div>

        <div class="form-field">
          <label class="field-label">Email <span class="required">*</span></label>
          <el-input
            v-model="formData.email"
            type="email"
            placeholder="correo@ejemplo.com"
            class="field-input"
          />
        </div>
      </div>
    </div>

    <div class="step-actions">
      <el-button type="primary" size="large" :disabled="!canProceed" :loading="isLoading" @click.stop="emit('next')" class="next-button">
        Siguiente
      </el-button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { User } from '@element-plus/icons-vue';
import type { EmissionFormData } from '@/types/emission.types';

interface Props {
  formData: EmissionFormData;
  canProceed: boolean;
  isLoading: boolean;
  allowEmission: boolean;
}

defineProps<Props>();

const emit = defineEmits<{
  next: [];
}>();
</script>

